/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Link_To_Web_Or_Pdf_SubtitleInputs */

const en_mobile_link_to_web_or_pdf_subtitle = /** @type {(inputs: Mobile_Link_To_Web_Or_Pdf_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the URL of a website or pdf`)
};

const es_mobile_link_to_web_or_pdf_subtitle = /** @type {(inputs: Mobile_Link_To_Web_Or_Pdf_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega la URL de un sitio web o PDF`)
};

/**
* | output |
* | --- |
* | "Paste the URL of a website or pdf" |
*
* @param {Mobile_Link_To_Web_Or_Pdf_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_link_to_web_or_pdf_subtitle = /** @type {((inputs?: Mobile_Link_To_Web_Or_Pdf_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Link_To_Web_Or_Pdf_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_link_to_web_or_pdf_subtitle(inputs)
	return en_mobile_link_to_web_or_pdf_subtitle(inputs)
});